<selfai-platform-data-sources
  [dataSource]="dataSource$ | async"
  [dataSourceList]="dataSources$ | async"
  [additionalList]="dataSourcesAdditions$ | async"
  [datasourceType]="type"
  (backEvent)="onBack()"
></selfai-platform-data-sources>
